import { DailyAudio } from '@daily-co/daily-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useWSTurnState, { TURN_PHASES } from '../hooks/useWSTurnState';
import Call from './Call/Call';
import Tray from './Tray/Tray';

const APP_PHASES = new Set([TURN_PHASES.Checkout]);

export default function AppRouter({ leaveCall }) {
  const { currentPhase } = useWSTurnState();
  const navigate = useNavigate();
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, '');

  useEffect(() => {
    if (APP_PHASES.has(currentPhase)) {
      navigate(`/checkout/${slug}`);
    }
  }, [currentPhase, navigate, slug]);

  return (
    <>
      <Call />
      <Tray leaveCall={leaveCall} />
      <DailyAudio />
    </>
  );
}
